import { CustomerOpenings, CustomerOpeningsTime } from "@TmpApp/types";
import { sortedWeekById } from "@TmpApp/Utils";
import { DateTime } from "luxon";
import * as React from "react";
import { OpenTodayProps } from ".";

const currentDay = DateTime.now();
const tommorowDay = DateTime.now().plus({ days: 1 });

const OpenToday: React.FC<OpenTodayProps> = ({
    openText = "Åbner kl:",
    closedText = "Lukket",
    closingText = "Lukker kl:",
    todayText = "i dag",
    tomorrowText = "imorgen",
    openings,
}) => {
    //useNextOpening(openings);
    const { closingTime, openingTime, isOpen } = useDay(openings, currentDay, new Date().getTime());
    const {
        closingTime: tomorrowClosingTime,
        openingTime: tomorrowOpeningTime,
        isOpen: tomorrowIsOpen,
    } = useDay(openings, tommorowDay, DateTime.now().startOf("day").toJSDate().getTime());

    const renderTodayText = () => {
        if (!closingTime) {
            return closedText + " " + todayText;
        }

        if (isOpen) {
            return closingText + " " + closingTime + " " + todayText;
        }

        return openText + " " + openingTime + " " + todayText;
    };

    const renderTomorrowText = () => {
        if (tomorrowOpeningTime) {
            return openText + " " + tomorrowOpeningTime + " " + tomorrowText;
        }

        return closedText + " " + tomorrowText;
    };

    return <div>{closingTime || isOpen ? renderTodayText() : renderTomorrowText()}</div>;
};

export default OpenToday;

const useNextOpening = (openings: CustomerOpenings) => {
    let weekSorted = openings.week.sort((a, b) => {
        return sortedWeekById[a.day] < sortedWeekById[b.day] ? -1 : 1;
    });

    console.log(weekSorted);

    const currentDayIndex = currentDay.toJSDate().getDay();

    const firstSplice = weekSorted.slice(0, currentDayIndex);
    const secondSplice = weekSorted.slice(currentDayIndex);

    const week = [...secondSplice, ...firstSplice];

    console.log(week);
};

const useDay = (openings: CustomerOpenings, comparisonDate: DateTime, currentTime: number) => {
    const week = openings.week.sort((a, b) => {
        return sortedWeekById[a.day] < sortedWeekById[b.day] ? -1 : 1;
    });

    let openingTime: string | undefined, closingTime: string | undefined;
    let isOpen: boolean = false;

    const day = week.find((day, index) => comparisonDate.toJSDate().getDay() === index);

    const handleCheckTime = (time: CustomerOpeningsTime) => {
        const fromTime = DateTime.fromFormat(time.from, "hh:mm");
        const toTime = DateTime.fromFormat(time.to, "hh:mm");

        if (fromTime.toJSDate().getTime() > currentTime && openingTime === undefined) {
            openingTime = time.from;
        }

        if (toTime.toJSDate().getTime() > currentTime) {
            closingTime = time.to;
        }

        if (
            fromTime.toJSDate().getTime() < currentTime &&
            toTime.toJSDate().getTime() > currentTime
        ) {
            isOpen = true;
        }
    };

    day?.times.map(handleCheckTime);

    openings.special?.map?.((special) => {
        const multipleDates = special.startEnd?.length > 1;

        if (!multipleDates) {
            const luxon = DateTime.fromJSDate(new Date(special.startEnd?.[0]));
            if (luxon.hasSame(comparisonDate, "day")) {
                if (special.open) {
                    isOpen = true;
                    special.times.map(handleCheckTime);
                } else {
                    isOpen = false;
                    closingTime = undefined;
                }
            }
        } else {
            special.dates
                .filter((date) => date)
                .map((date) => {
                    const luxon = DateTime.fromJSDate(new Date(date.date));
                    if (luxon.hasSame(comparisonDate, "day")) {
                        if (date.open) {
                            isOpen = true;
                            date.times.map(handleCheckTime);
                        } else {
                            isOpen = false;
                            closingTime = undefined;
                        }
                    }
                });
        }
    });

    return { openingTime, closingTime, isOpen };
};
